import { GoogleMapsLibrary } from '~/framework/helpers/google/google-maps-library';

import { type AutocompletePrediction, type LatLng } from './interfaces';

export default class GmapsMapPlaces {
    static async places(map: HTMLDivElement | google.maps.Map | undefined) : Promise<GmapsMapPlaces> {
        const placesLibrary = await GoogleMapsLibrary.placesLibrary();
        return new GmapsMapPlaces(placesLibrary, map);
    }
	
    private readonly _placesLibrary: google.maps.PlacesLibrary;
    private readonly _autocompleteService: google.maps.places.AutocompleteService;
    private readonly _placesService: google.maps.places.PlacesService | undefined;
	
    constructor(placesLibrary: google.maps.PlacesLibrary, map: HTMLDivElement | google.maps.Map | undefined) {
        this._placesLibrary = placesLibrary;
        const { AutocompleteService: autocompleteService, PlacesService: placesService } = placesLibrary;
        this._autocompleteService = new autocompleteService();
        this._placesService = map ?  new placesService(map) : undefined;
    }

    async getPlaceLocation(placeId: string) {
        const result: google.maps.places.PlaceResult | null = await new Promise<google.maps.places.PlaceResult | null>((resolve, reject) =>{
            const fields = ['name','geometry','place_id','formatted_address','address_components'];
            if(this._placesService) {
                this._placesService.getDetails(
                    {
                        placeId,
                        fields,  
                    },
                    (result, status: google.maps.places.PlacesServiceStatus) => {
                        if(status === 'OK') {
                            resolve(result)
                        } else {
                            reject(status);
                        }
                    }
                );
            } else {
                console.error('Unable to get place details as map component has not been supplied.');
                resolve(null);
            }

        });
        // console.log("details",result?.formatted_address)
        return result;
    }

    async getPlacePredictions(input: string, origin: LatLng | undefined): Promise<AutocompletePrediction[]> {
        const locationRestriction = origin ? new google.maps.Circle({center: origin, radius: 50_000}).getBounds() : undefined;
        const request: google.maps.places.AutocompletionRequest =origin? {
            input,
            locationRestriction,
            location:  new google.maps.LatLng(origin.lat, origin.lng),
            radius: 50_000,
        }:{
            input,
            region:'au'
        };
        const result: google.maps.places.AutocompleteResponse = await this._autocompleteService.getPlacePredictions(request);
        // console.log(result,"gmap");
        return result.predictions.map((prediction) => this._transformPlacePrediction(prediction))
    }

    _transformPlacePrediction(prediction: google.maps.places.AutocompletePrediction): AutocompletePrediction {
        const { place_id: placeId, structured_formatting: structuredFormatting } = prediction;
        const { main_text: mainText, secondary_text: secondaryText, main_text_matched_substrings: mainTextMatchedSubstrings } = structuredFormatting;
        let htmlText = mainText;
        mainTextMatchedSubstrings.reverse();

        for (const ss of mainTextMatchedSubstrings) {
            htmlText = htmlText.slice(0, (ss.length + ss.offset)) + "</b>" + htmlText.slice((ss.length + ss.offset));
            htmlText = htmlText.slice(0, ss.offset) + "<b>" + htmlText.slice(ss.offset);
        }

        return {
            htmlText,
            placeId,
            textLocation: secondaryText,
            title: mainText,
        }
    }
}
